import * as React from 'react'
import styled from 'styled-components'
import { ConfigUiHint, JsonSchema } from '../../../types'

type Props = {
  label: string
  value: string
  schema: JsonSchema
  hint?: ConfigUiHint
  disabled?: boolean
  onChange: (val: string) => void
}

const Wrapper = styled.div`
  margin-bottom: 16px;
`

const Label = styled.label`
  display: block;
  color: ${(p) => p.theme.label};
  font-size: 12px;
  margin-bottom: 4px;
  font-family: 'NunitoSansSemiBold';
`

const Input = styled.input`
  background: ${(p) => p.theme.input.default};
  border: none;
  border-radius: ${(p) => p.theme.radius};
  color: ${(p) => p.theme.white};
  caret-color: ${(p) => p.theme.white};
  padding: 10px 12px;
  font-size: 14px;
  outline: none;
  width: 100%;
  box-sizing: border-box;
  min-height: 44px;

  &::placeholder { color: ${(p) => p.theme.listDesc}; }
  &:focus { box-shadow: 0 0 0 2px ${(p) => p.theme.accent}; outline: none; }
  &:disabled {
    background: ${(p) => p.theme.input.disabled};
    cursor: not-allowed;
  }
`

const HelpText = styled.span`
  display: block;
  color: ${(p) => p.theme.listDesc};
  font-size: 12px;
  margin-top: 4px;
`

export function TextField({ label, value, hint, disabled, onChange }: Props) {
  return (
    <Wrapper>
      <Label>{label}</Label>
      <Input
        type="text"
        value={value ?? ''}
        placeholder={hint?.placeholder ?? ''}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
      />
      {hint?.help && <HelpText>{hint.help}</HelpText>}
    </Wrapper>
  )
}
